import { TextField } from "@mui/material";
import { useValidation } from "../../helpers/validationHelpers";
import { useState } from "react";
import InputAdornment from "@mui/material/InputAdornment";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

// import InnoTextInput from "../components/inputs/InnoTextInput";
// a reusable text input field for various text inputs
export default function InnoTextInput({
  width,
  height,
  textField,
  multiline, // OPTIONAL
  rows, // OPTIONAL
  styledProps,
  placeholder,
  placeholderStyles, // OPTIONAL
  handleFunc, //OPTIONAL
  disabled, // OPTIONAL
  noborder, // OPTIONAL or REQUIRED FOR showing border, the name of the field
  fieldValue, // REQUIRED the field value
  setValue, // REQUIRED a callback that accepts the new value and changes it
  fieldName, // OPTIONAL or REQUIRED FOR ERROR HANDLING, the name of the field
  validate, // OPTIONAL or REQUIRED FOR ERROR HANDLING, a validation callback function
  errors, // OPTIONAL or REQUIRED FOR ERROR HANDLING
  feedbackError, // OPTIONAL, outline the field in red if true for feedback from backend
  uniqeNameBoolean = true, //OPTIONAL, check if the name is unique, if it is false, show the error msg
  uniqeNameMsg, //OPTIONAL, msg showing the error if not uniqe name
  errorIcon, //OPTIONAL, showing the initial right error icon or not
  showErrorIconWithError = true, //OPTIONAL, if true, the error icon will show when there is an error
  /* errors object in the following format (as returned from useValidation): 
            {
                [fieldname1]: {
                    isValid: false, 
                    errorMessages: {
                        [validationName1]: "Error message",   
                        [validationName2]: "Error message", 
                    }
                },
                [fieldname2]: {
                    isValid: true,
                    errorMessages: {}
                }
            } 
        */
}) {
  function handleInputChange(e) {
    // actions controlled by this component go here
    if (validate && fieldName) {
      validate(fieldName, e.target.value);
    }

    // set the value with callback from props
    setValue(e.target.value);
  }

    return (
        <TextField
          disabled={disabled}
          value={fieldValue ? fieldValue : ""}
          onChange={handleInputChange}
          error={ (!uniqeNameBoolean)? true: (feedbackError ? true : (errors && fieldName && errors[fieldName] ? !errors[fieldName]?.isValid : 
              false))}
          helperText={(!uniqeNameBoolean)? uniqeNameMsg : (errors && fieldName && errors[fieldName] ? Object.values(errors[fieldName]?.errorMessages).join("; ") : null)}
          sx={{
            // this field should be a fixed height but should fit the width of its container
            width: width || "100%",
            height: textField? "320px": height? height: "30px",
            border: "1.5px solid var(--Neutrals-500, #E2E6E9)",
            borderRadius: "6px",
            ...(noborder
                ? {
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        border: "none", // Remove the border or outline
                      },
                    },
                  }
                : {}),
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                border: "1px solid #E9ECEE", 
                opacity: 1
              },
              '&:hover fieldset': {
                borderColor: errors && fieldName && errors[fieldName] && !errors[fieldName].isValid? "red" : "#a7d9f1"                                  
              },
              '&.Mui-focused fieldset': {
                  borderColor: errors && fieldName && errors[fieldName]&&!errors[fieldName].isValid? "red" : "#a7d9f1"
              }
            },
            "& input::placeholder": {
              color: "var(--Neutrals-700, #C6CCD2)",
              fontSize: "14px",
              fontFamily: "Lato",
              fontWeight: 700,
              ...placeholderStyles
            },
          }}
          InputProps={{
            endAdornment: (
              errorIcon? (
                <InputAdornment position="end">
                  <ErrorOutlineIcon 
                    sx={{ color: errors && !errors[[fieldName]]?.isValid ? "#F5325B" : "#E3E3E3"}} 
                  />
                </InputAdornment>
              ) : (
                <InputAdornment position="end">
                  {showErrorIconWithError && errors && !errors[[fieldName]]?.isValid && <ErrorOutlineIcon color="error" />}
                </InputAdornment>
              )
              
            ),
              style: {
                  height: textField? null : height? height: "30px",
                  textAlign: "left",
                  fontFamily: "Lato",
                  fontWeight: "bold",
                  fontSize: "14px",
                  lineHeight: "18px",
                  letterSpacing: "0px",
                  color: "black",
                  opacity: 1,
                  ...styledProps
              }
          }}
          
          multiline={multiline? true: false}
          rows={rows? rows: 1}
          placeholder={placeholder}
          onBlur={handleFunc? handleFunc: null}
        />
    )
}

export function InnoTextInputExample() {
    const [name, setName] = useState("");
    const [jobTitle, setJobTitle] = useState("");
    const { errors, validate } = useValidation({
        name: {
            isNotBlank: true,
        },
        jobTitle: {}
    });

    return (
        <div>
            Name:
            <InnoTextInput
                fieldValue={name}
                setValue={setName}
                fieldName="name"
                validate={validate}
                errors={errors}
            />
            Job Title:
            <InnoTextInput
                fieldValue={jobTitle}
                setValue={setJobTitle}
                fieldName="jobTitle"
            />
        </div>
    )
}